import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { CierreForm } from "./components/CierreForm";
import "./styles/CreacionCierre.css";
import "./styles/RelojCierre.css";

class CreacionCierre extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    navigateToDetalleCierre = (cierreId) => {
        this.props.history.replace(
            `/produccion-bodega/inventario/cierre/${cierreId}`,
        );
    };

    // sin documento en proceso no hay nada que trabajar aquí, así que se
    // devuelve al listado, que es de donde se abre
    navigateToListadoCierres = () => {
        this.props.history.replace("/produccion-bodega/inventario?tab=CIERRES");
    };

    render() {
        const { user } = this.props;

        const nombreUsuario = user ? user.nombre : "No definido";

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "91vw", margin: "auto" }}
            >
                <CardForm
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Cierre de inventario en proceso"
                    col="12"
                >
                    <CierreForm
                        regresar={this.regresar}
                        navigateToDetalleCierre={this.navigateToDetalleCierre}
                        navigateToListadoCierres={this.navigateToListadoCierres}
                        nombreUsuario={nombreUsuario}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(CreacionCierre);
